

function syncInterval() {
  console.log('function called');
  var activeItem = document.querySelector('.product-reductions__item.active');
  if (!activeItem) return;
  var qty = activeItem.dataset.quantity;
  var select = document.querySelector('.sls-select[name="subs_interval"]');
  if (!select) return;
  Array.from(select.options).forEach(function(opt) {
    if (opt.textContent.trim().startsWith(qty + ' ')) {
      select.selectedIndex = opt.index;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}

function updateSavingsLabels(mode) {
  
  document.querySelector('.product-reductions__wrapper').classList.remove('one_time');
  document.querySelector('.product-reductions__wrapper').classList.remove('subscription');
  document.querySelector('.product-reductions__wrapper').classList.add(mode);
  
}

document.addEventListener('DOMContentLoaded', function() {
  // subscription tab toggles
  var tabs = document.querySelectorAll('.subscription_flex .subscription_item');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      tabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');

      var mode = this.querySelector('.price_trigger') ? 'subscription' : 'one_time';
      document.querySelectorAll('.product-reductions__item').forEach(function(item) {
        var priceKey = mode === 'subscription' ? 'subPrice' : 'salePrice';
        item.querySelector('.product-reductions__compare').textContent = item.dataset.comparePrice;
        item.querySelector('.product-reductions__sale').textContent    = item.dataset[priceKey];

        if(item.classList.contains('active')){
                   var priceKey = mode === 'subscription' ? 'subPrice' : 'salePrice';
      setTimeout(function(){
      var selector = document.querySelector('.price-item.price-item--sale span') != undefined ?   document.querySelector('.price-item.price-item--sale span'): document.querySelector('.price-item.price-item--sale');
     console.log(priceKey);
        console.log(selector);
        selector.textContent = item.dataset[priceKey];
        },500);
        }
        
      });

      document.querySelectorAll('.sls-option[data-type]').forEach(function(opt) {
        if (opt.dataset.type === mode) {
          opt.checked = true;
          opt.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });



      updateSavingsLabels(mode);
      if (mode === 'subscription') syncInterval();
    });
  });


    var active = document.querySelector('.subscription_flex .subscription_item.active');
    if (!active) return;
      var mode = 'subscription';
    // var mode = active.querySelector('.price_trigger') ? 'subscription' : 'one_time';

   document.querySelectorAll('.product-reductions__item').forEach(function(item) {
      var priceKey = mode === 'subscription' ? 'subPrice' : 'salePrice';
      item.querySelector('.product-reductions__compare').textContent = item.dataset.comparePrice;
      item.querySelector('.product-reductions__sale').textContent    = item.dataset[priceKey];
    });
  
      console.log(mode);
  updateSavingsLabels(mode);
  // after the sealsubs widget is created
  document.addEventListener('sealsubs:subscription_widget_created', function() {
  setTimeout(function(){
  document.querySelectorAll('.sls-option[data-type]').forEach(function(opt) {
      if (opt.dataset.type === mode) {
        opt.checked = true;
        opt.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    if (mode === 'subscription') syncInterval();
    },500);
  });

  // clicking on a reduction pack
  document.querySelectorAll('.product-reductions__item').forEach(function(item) {
    item.addEventListener('click', function() {
      document.querySelectorAll('.product-reductions__item').forEach(i => i.classList.remove('active'));
      this.classList.add('active');
      document.getElementById('quantityReductions').value = this.dataset.quantity;



      var active = document.querySelector('.subscription_flex .subscription_item.active');
    if (!active) return;
      var mode = active.querySelector('.price_trigger') ? 'subscription' : 'one_time';
         var priceKey = mode === 'subscription' ? 'subPrice' : 'salePrice';

     setTimeout(function(){
      var selector = document.querySelector('.price-item.price-item--sale span') != undefined ?   document.querySelector('.price-item.price-item--sale span'): document.querySelector('.price-item.price-item--sale');
     console.log(priceKey);
        console.log(selector);
        selector.textContent = item.dataset[priceKey];
        },500);

      if (document.querySelector('.subscription_flex .subscription_item.active .price_trigger')) {
        syncInterval();
      }
    });
  });

  // add‐to‐cart override for bundler
  var atcBtn = document.querySelector('.product__add-to-cart');
  if (atcBtn) {
    atcBtn.addEventListener('click', function(e) {
      var qty = document.getElementById('quantityReductions').value;
      if (qty !== '1') {
        e.preventDefault();
        var sel = '.bndlr-volume-discount[data-quantity="' + qty + '"] .bndlr-volume-saving-text';
        var btn = document.querySelector(sel);
        if (btn) btn.click();
        else console.warn('No bundler button for quantity:', qty);
      }
    });
  }
});
